export const checkPermissions = (rolesVision: Record<string, string[]>, module: string) => {
    const actions = ['create', 'update', 'delete', 'visible'];

    return actions.reduce((permissions, action) => {
        permissions[action] = rolesVision[module]?.includes(action);
        return permissions;
    }, {} as Record<string, boolean>);
};

export const getAudioControlPermissions = (rolesVision: Record<string, string[]>) => {
    return checkPermissions(rolesVision, 'QualityControl');
};
